var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgNewcsDashboardListDownIcon = function SvgNewcsDashboardListDownIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 12
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "newcs_dashboard_list_down_icon_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#707070",
    d: "M194 435h10v12h-10z",
    "data-name": "\\u77E9\\u5F62 464"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#38b16a",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    clipPath: "url(#newcs_dashboard_list_down_icon_svg__a)",
    transform: "translate(-194 -435)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "m194.776 442.042 4.229 4.221 4.229-4.221",
    "data-name": "\\u8DEF\\u5F84 381"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.998 445.777v-10",
    "data-name": "\\u8DEF\\u5F84 382"
  }))));
};
export default SvgNewcsDashboardListDownIcon;